import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '../../../core/notifications/notification.service';
import { ToastService } from '../../../core/toast/toast.service';
import { DeadlineAlert } from '../../../core/notifications/deadline-alert.model';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.html',
  styleUrl: './toast-container.css',
})
export class ToastContainerComponent {
  protected readonly notifications = inject(NotificationService);
  protected readonly toastService = inject(ToastService);
  private readonly router = inject(Router);

  protected dismiss(alert: DeadlineAlert): void {
    this.notifications.dismiss(alert);
  }

  protected mute(alert: DeadlineAlert): void {
    this.notifications.mute(alert);
  }

  protected openAlert(alert: DeadlineAlert): void {
    this.notifications.dismiss(alert);
    this.router.navigate(alert.link);
  }

  protected dismissToast(id: number): void {
    this.toastService.dismiss(id);
  }
}
